import React from 'react';
import clsx from 'clsx';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import FacebookIcon from '@material-ui/icons/Facebook';
import InstagramIcon from '@material-ui/icons/Instagram';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import logoWhite from '../../img/CS-Logo-white.png';
import Link from '@material-ui/core/Link';

const useStyles = makeStyles((theme) => ({
  menuButton: {
    marginRight: theme.spacing(2),
  },
  hide: {
    display: 'none',
  },
  appBar: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    zIndex: theme.zIndex.drawer + 1,
  },
  appBarShift: {
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  toolbar: {
    color: 'white',
  },
  tooltip: {
    backgroundColor: theme.palette.common.white,
    color: 'rgba(0, 0, 0, 0.87)',
    boxShadow: theme.shadows[1],
    fontSize: 11,
  },
  title: {
    flexGrow: 1,
  },
  grow: {
    flexGrow: 1,
  },
  logo: {
    height: '50px',
  },
}));

export function Header(props) {
  const classes = useStyles();

  const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: theme.palette.common.white,
      color: 'rgba(0, 0, 0, 0.87)',
      boxShadow: theme.shadows[1],
      fontSize: 11,
      fontWeight: 800,
      margin: '5px',
    },
  }))(Tooltip);
  return (
    <div className={classes.grow}>
      <AppBar
        elevation={0}
        color="transparent"
        position="fixed"
        className={clsx(classes.appBar, {
          [classes.appBarShift]: false,
        })}
      >
        <Toolbar variant="regular" className={classes.toolbar}>
          <Link href="/app/">
            <img src={logoWhite} alt="CS Logo" className={classes.logo} />
          </Link>
          <div className={classes.grow} />
          <LightTooltip
            id="instagram-facebook"
            title="Follow us on facebook"
            placement="bottom-start"
          >
            <IconButton color="inherit" href="https://www.facebook.com/AIESECLK">
              <FacebookIcon />
            </IconButton>
          </LightTooltip>
          <LightTooltip
            id="instagram-facebook"
            title="Follow us on instagram"
            placement="bottom-start"
          >
            <IconButton color="inherit" href="https://www.instagram.com/lc_colombo_south/">
              <InstagramIcon />
            </IconButton>
          </LightTooltip>
        </Toolbar>
      </AppBar>
    </div>
  );
}
